import React from "react";
import Image from "../ImgComponent";
import Link from "next/link";
import moment from "moment-mini";
import styles from "./NewsCard.module.scss";
import classNames from "classnames";
import { highlightText } from "./../../common/highlightText";

const NewsCardHorizontal = ({
  id,
  slug,
  title,
  desc,
  created_at,
  src,
  locale,
  objectFit,
  query,
  isHighlight,
}) => {
  let cloneSlug = slug?.split("-") ?? [];
  cloneSlug.splice(cloneSlug.length - 1, 1);

  const renderTitle = () => {
    if (isHighlight && query) {
      return highlightText(title, query);
    }
    return title;
  };

  const renderDescription = () => {
    if (isHighlight && query) {
      return highlightText(desc, query);
    }
    return desc;
  };

  return (
    <div>
      <div className="row">
        <div className="col-12 col-md-4 mb-3 mb-md-0">
          <Link as={`/news/${cloneSlug?.join("-")}-${id}`} href={`/news/${id}`}>
            <a className="w-100">
              <Image
                objectFit={objectFit || "cover"}
                width={480}
                height={270}
                layout="responsive"
                //   className={classNames("img-fluid", styles.newsImg)}
                src={src}
                alt={title + " thumb"}
              />
            </a>
          </Link>
        </div>
        <div className="col-12 col-md-8">
          <small>
            {moment(created_at).format(
              locale === "vi" ? "DD/MM/YYYY" : "DD MMMM YYYY"
            )}
          </small>
          <Link as={`/news/${slug}-${id}`} href={`/news/${id}`}>
            <a>
              <h5
                className={classNames(
                  "my-1 text-darken-blue default-text-size",
                  styles.newsCardTitle
                )}
                dangerouslySetInnerHTML={{ __html: renderTitle() }}
              />
            </a>
          </Link>
          <p
            className={classNames("mb-2", styles.newsCardDesc)}
            style={{ fontSize: "14px" }}
            dangerouslySetInnerHTML={{ __html: renderDescription() }}
          />
        </div>
      </div>
    </div>
  );
};

export default NewsCardHorizontal;
